import React, { Component } from 'react';
import loadingImage from '../img/loading.svg'

class Recordloading extends Component {

  render() {
      return (
        <div className="row loading-div">
          <div>
            <img src={loadingImage} alt="loading" />
          </div>
          <h5>
              درحال بارگزاری رکوردها ...
          </h5>
        </div>
      );
  }
}

export default Recordloading;